/* NESTORA - wishlist hearts. Saves real product ids in localStorage on this device. */
(function () {
  var KEY = 'nestora-wishlist';
  var HEART =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.4S3.8 15.3 3.8 9.7A4.3 4.3 0 0 1 12 7.4a4.3 4.3 0 0 1 8.2 2.3c0 5.6-8.2 10.7-8.2 10.7Z"/></svg>';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (error) {
      /* storage unavailable - the heart simply will not persist */
    }
  }

  function paint(button, saved) {
    button.classList.toggle('is-saved', saved);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
  }

  function inject() {
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.querySelector('[data-nst-wish]')) return;

      var link = card.querySelector('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
      if (!link) return;

      var match = link.id.match(/(\d+)$/);
      if (!match) return;

      var host = card.querySelector('.card__inner') || card;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'nst-wish';
      button.setAttribute('data-nst-wish', match[1]);
      button.setAttribute('aria-label', 'Save to wishlist');
      button.setAttribute('aria-pressed', 'false');
      button.innerHTML = HEART;
      host.appendChild(button);
    });
  }

  function bind() {
    var saved = read();

    document.querySelectorAll('[data-nst-wish]').forEach(function (button) {
      var id = button.getAttribute('data-nst-wish');
      paint(button, saved.indexOf(id) !== -1);

      if (button.getAttribute('data-nst-wish-bound')) return;
      button.setAttribute('data-nst-wish-bound', '1');

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var list = read();
        var index = list.indexOf(id);
        var nowSaved = index === -1;

        if (nowSaved) {
          list.push(id);
        } else {
          list.splice(index, 1);
        }
        write(list);

        document.querySelectorAll('[data-nst-wish="' + id + '"]').forEach(function (twin) {
          paint(twin, nowSaved);
        });
      });
    });
  }

  function start() {
    inject();
    bind();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
